import { patchErrorInspect } from '../patch-error-inspect'

patchErrorInspect()
